import { Table } from 'react-bootstrap';
import { useGetDailyStoreStocksQuery } from '../../slices/dailyStoreStocksApiSlice';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import { useMemo } from 'react';

const DailyStoreStockUniqueDates = () => {
  const { data, isLoading, error } = useGetDailyStoreStocksQuery();

  const dailyStoreStocks = useMemo(() => data?.dailyStoreStocks || [], [data]);

  const uniqueDates = useMemo(() => {
    return dailyStoreStocks.length > 0 
      ? [...new Set(dailyStoreStocks.map(dailyStoreStock => new Date(dailyStoreStock.date).toISOString().split('T')[0]))]
      : [];
  }, [dailyStoreStocks]);

  const sortedDates = useMemo(() => [...uniqueDates].sort((a, b) => new Date(a) - new Date(b)), [uniqueDates]);
  const date1 = sortedDates;
  
  return (
    <>
      <h1>Unique DailyMiniStock Dates</h1>
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error?.data?.message || 'Error fetching dailyStoreStock dates'}</Message>
      ) : (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>DATE</th>
            </tr>
          </thead>
          <tbody>
            {date1.map((date, index) => (
              <tr key={index}>
                <td>{date}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default DailyStoreStockUniqueDates;
